export default "__VITE_ASSET__D67vG_uz__"